module.exports = __webpack_public_path__ + "media/images/icon-bgm-off@3x-d9578bbb2cd1a5ecd46e248989152ff3.png";